import { usePlatformAuthorizeInfoLazyQuery } from './gql/graphql.v5.generated';

export const usePlatformAuthorizeInfo = () => {
  const [fetchPlatformAuthorizeInfo, { loading }] = usePlatformAuthorizeInfoLazyQuery({
    context: {
      v5: true,
      batch: true,
    },
    fetchPolicy: 'network-only',
  });

  const checkIsNeedPhoneVerification = async () => {
    const { data } = await fetchPlatformAuthorizeInfo();

    const isUserHasPhone = Boolean(
      data?.me
      && data.me.phoneNumber,
    );
    const isAuthorizeInfoExpired = Boolean(
      data?.me && (
        !data.me.platformAuthorizeInfo
        || data.me.platformAuthorizeInfo?.isExpired
      ),
    );

    return !isUserHasPhone || isAuthorizeInfoExpired;
  };

  return {
    loading,
    checkIsNeedPhoneVerification,
  };
};
